// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/franklin/region.proto (package squareup.franklin, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_squareup_objc_objc } from "../objc/objc_pb";

/**
 * Describes the file squareup/franklin/region.proto.
 */
export const file_squareup_franklin_region: GenFile = /*@__PURE__*/
  fileDesc("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", [file_squareup_objc_objc]);

/**
 * *
 * ISO 3166-1 alpha-3 country codes for regions supported in Cash.
 * See https://en.wikipedia.org/wiki/ISO_3166-1
 *
 * @generated from enum squareup.franklin.Region
 */
export enum Region {
  /**
   * @generated from enum value: USA = 1;
   */
  USA = 1,

  /**
   * @generated from enum value: CAN = 2;
   */
  CAN = 2,

  /**
   * *
   * GBR stands for "The United Kingdom of Great Britain and Northern Ireland", not just "Great Britain".
   *
   * @generated from enum value: GBR = 3;
   */
  GBR = 3,

  /**
   * @generated from enum value: AUS = 4;
   */
  AUS = 4,

  /**
   * @generated from enum value: ABW = 5;
   */
  ABW = 5,

  /**
   * @generated from enum value: AFG = 6;
   */
  AFG = 6,

  /**
   * @generated from enum value: AGO = 7;
   */
  AGO = 7,

  /**
   * @generated from enum value: AIA = 8;
   */
  AIA = 8,

  /**
   * @generated from enum value: ALA = 9;
   */
  ALA = 9,

  /**
   * @generated from enum value: ALB = 10;
   */
  ALB = 10,

  /**
   * @generated from enum value: AND = 11;
   */
  AND = 11,

  /**
   * @generated from enum value: ARE = 12;
   */
  ARE = 12,

  /**
   * @generated from enum value: ARG = 13;
   */
  ARG = 13,

  /**
   * @generated from enum value: ARM = 14;
   */
  ARM = 14,

  /**
   * @generated from enum value: ASM = 15;
   */
  ASM = 15,

  /**
   * @generated from enum value: ATA = 16;
   */
  ATA = 16,

  /**
   * @generated from enum value: ATF = 17;
   */
  ATF = 17,

  /**
   * @generated from enum value: ATG = 18;
   */
  ATG = 18,

  /**
   * @generated from enum value: AUT = 19;
   */
  AUT = 19,

  /**
   * @generated from enum value: AZE = 20;
   */
  AZE = 20,

  /**
   * @generated from enum value: BDI = 21;
   */
  BDI = 21,

  /**
   * @generated from enum value: BEL = 22;
   */
  BEL = 22,

  /**
   * @generated from enum value: BEN = 23;
   */
  BEN = 23,

  /**
   * @generated from enum value: BES = 24;
   */
  BES = 24,

  /**
   * @generated from enum value: BFA = 25;
   */
  BFA = 25,

  /**
   * @generated from enum value: BGD = 26;
   */
  BGD = 26,

  /**
   * @generated from enum value: BGR = 27;
   */
  BGR = 27,

  /**
   * @generated from enum value: BHR = 28;
   */
  BHR = 28,

  /**
   * @generated from enum value: BHS = 29;
   */
  BHS = 29,

  /**
   * @generated from enum value: BIH = 30;
   */
  BIH = 30,

  /**
   * @generated from enum value: BLM = 31;
   */
  BLM = 31,

  /**
   * @generated from enum value: BLR = 32;
   */
  BLR = 32,

  /**
   * @generated from enum value: BLZ = 33;
   */
  BLZ = 33,

  /**
   * @generated from enum value: BMU = 34;
   */
  BMU = 34,

  /**
   * @generated from enum value: BOL = 35;
   */
  BOL = 35,

  /**
   * @generated from enum value: BRA = 36;
   */
  BRA = 36,

  /**
   * @generated from enum value: BRB = 37;
   */
  BRB = 37,

  /**
   * @generated from enum value: BRN = 38;
   */
  BRN = 38,

  /**
   * @generated from enum value: BTN = 39;
   */
  BTN = 39,

  /**
   * @generated from enum value: BVT = 40;
   */
  BVT = 40,

  /**
   * @generated from enum value: BWA = 41;
   */
  BWA = 41,

  /**
   * @generated from enum value: CAF = 42;
   */
  CAF = 42,

  /**
   * @generated from enum value: CCK = 43;
   */
  CCK = 43,

  /**
   * @generated from enum value: CHE = 44;
   */
  CHE = 44,

  /**
   * @generated from enum value: CHL = 45;
   */
  CHL = 45,

  /**
   * @generated from enum value: CHN = 46;
   */
  CHN = 46,

  /**
   * @generated from enum value: CIV = 47;
   */
  CIV = 47,

  /**
   * @generated from enum value: CMR = 48;
   */
  CMR = 48,

  /**
   * @generated from enum value: COD = 49;
   */
  COD = 49,

  /**
   * @generated from enum value: COG = 50;
   */
  COG = 50,

  /**
   * @generated from enum value: COK = 51;
   */
  COK = 51,

  /**
   * @generated from enum value: COL = 52;
   */
  COL = 52,

  /**
   * @generated from enum value: COM = 53;
   */
  COM = 53,

  /**
   * @generated from enum value: CPV = 54;
   */
  CPV = 54,

  /**
   * @generated from enum value: CRI = 55;
   */
  CRI = 55,

  /**
   * @generated from enum value: CUB = 56;
   */
  CUB = 56,

  /**
   * @generated from enum value: CUW = 57;
   */
  CUW = 57,

  /**
   * @generated from enum value: CXR = 58;
   */
  CXR = 58,

  /**
   * @generated from enum value: CYM = 59;
   */
  CYM = 59,

  /**
   * @generated from enum value: CYP = 60;
   */
  CYP = 60,

  /**
   * @generated from enum value: CZE = 61;
   */
  CZE = 61,

  /**
   * @generated from enum value: DEU = 62;
   */
  DEU = 62,

  /**
   * @generated from enum value: DJI = 63;
   */
  DJI = 63,

  /**
   * @generated from enum value: DMA = 64;
   */
  DMA = 64,

  /**
   * @generated from enum value: DNK = 65;
   */
  DNK = 65,

  /**
   * @generated from enum value: DOM = 66;
   */
  DOM = 66,

  /**
   * @generated from enum value: DZA = 67;
   */
  DZA = 67,

  /**
   * @generated from enum value: ECU = 68;
   */
  ECU = 68,

  /**
   * @generated from enum value: EGY = 69;
   */
  EGY = 69,

  /**
   * @generated from enum value: ERI = 70;
   */
  ERI = 70,

  /**
   * @generated from enum value: ESH = 71;
   */
  ESH = 71,

  /**
   * @generated from enum value: ESP = 72;
   */
  ESP = 72,

  /**
   * @generated from enum value: EST = 73;
   */
  EST = 73,

  /**
   * @generated from enum value: ETH = 74;
   */
  ETH = 74,

  /**
   * @generated from enum value: FIN = 75;
   */
  FIN = 75,

  /**
   * @generated from enum value: FJI = 76;
   */
  FJI = 76,

  /**
   * @generated from enum value: FLK = 77;
   */
  FLK = 77,

  /**
   * @generated from enum value: FRA = 78;
   */
  FRA = 78,

  /**
   * @generated from enum value: FRO = 79;
   */
  FRO = 79,

  /**
   * @generated from enum value: FSM = 80;
   */
  FSM = 80,

  /**
   * @generated from enum value: GAB = 81;
   */
  GAB = 81,

  /**
   * @generated from enum value: GEO = 82;
   */
  GEO = 82,

  /**
   * @generated from enum value: GGY = 83;
   */
  GGY = 83,

  /**
   * @generated from enum value: GHA = 84;
   */
  GHA = 84,

  /**
   * @generated from enum value: GIB = 85;
   */
  GIB = 85,

  /**
   * @generated from enum value: GIN = 86;
   */
  GIN = 86,

  /**
   * @generated from enum value: GLP = 87;
   */
  GLP = 87,

  /**
   * @generated from enum value: GMB = 88;
   */
  GMB = 88,

  /**
   * @generated from enum value: GNB = 89;
   */
  GNB = 89,

  /**
   * @generated from enum value: GNQ = 90;
   */
  GNQ = 90,

  /**
   * @generated from enum value: GRC = 91;
   */
  GRC = 91,

  /**
   * @generated from enum value: GRD = 92;
   */
  GRD = 92,

  /**
   * @generated from enum value: GRL = 93;
   */
  GRL = 93,

  /**
   * @generated from enum value: GTM = 94;
   */
  GTM = 94,

  /**
   * @generated from enum value: GUF = 95;
   */
  GUF = 95,

  /**
   * @generated from enum value: GUM = 96;
   */
  GUM = 96,

  /**
   * @generated from enum value: GUY = 97;
   */
  GUY = 97,

  /**
   * @generated from enum value: HKG = 98;
   */
  HKG = 98,

  /**
   * @generated from enum value: HMD = 99;
   */
  HMD = 99,

  /**
   * @generated from enum value: HND = 100;
   */
  HND = 100,

  /**
   * @generated from enum value: HRV = 101;
   */
  HRV = 101,

  /**
   * @generated from enum value: HTI = 102;
   */
  HTI = 102,

  /**
   * @generated from enum value: HUN = 103;
   */
  HUN = 103,

  /**
   * @generated from enum value: IDN = 104;
   */
  IDN = 104,

  /**
   * @generated from enum value: IMN = 105;
   */
  IMN = 105,

  /**
   * @generated from enum value: IND = 106;
   */
  IND = 106,

  /**
   * @generated from enum value: IOT = 107;
   */
  IOT = 107,

  /**
   * *
   * As of 2021-09-30, Cash currently uses XXL to represent Ireland, not IRL.
   * If things change in the future, please un-deprecate this key,
   * See go/$customer-region
   *
   * @generated from enum value: IRL = 108 [deprecated = true];
   * @deprecated
   */
  IRL = 108,

  /**
   * @generated from enum value: IRN = 109;
   */
  IRN = 109,

  /**
   * @generated from enum value: IRQ = 110;
   */
  IRQ = 110,

  /**
   * @generated from enum value: ISL = 111;
   */
  ISL = 111,

  /**
   * @generated from enum value: ISR = 112;
   */
  ISR = 112,

  /**
   * @generated from enum value: ITA = 113;
   */
  ITA = 113,

  /**
   * @generated from enum value: JAM = 114;
   */
  JAM = 114,

  /**
   * @generated from enum value: JEY = 115;
   */
  JEY = 115,

  /**
   * @generated from enum value: JOR = 116;
   */
  JOR = 116,

  /**
   * @generated from enum value: JPN = 117;
   */
  JPN = 117,

  /**
   * @generated from enum value: KAZ = 118;
   */
  KAZ = 118,

  /**
   * @generated from enum value: KEN = 119;
   */
  KEN = 119,

  /**
   * @generated from enum value: KGZ = 120;
   */
  KGZ = 120,

  /**
   * @generated from enum value: KHM = 121;
   */
  KHM = 121,

  /**
   * @generated from enum value: KIR = 122;
   */
  KIR = 122,

  /**
   * @generated from enum value: KNA = 123;
   */
  KNA = 123,

  /**
   * @generated from enum value: KOR = 124;
   */
  KOR = 124,

  /**
   * @generated from enum value: KWT = 125;
   */
  KWT = 125,

  /**
   * @generated from enum value: LAO = 126;
   */
  LAO = 126,

  /**
   * @generated from enum value: LBN = 127;
   */
  LBN = 127,

  /**
   * @generated from enum value: LBR = 128;
   */
  LBR = 128,

  /**
   * @generated from enum value: LBY = 129;
   */
  LBY = 129,

  /**
   * @generated from enum value: LCA = 130;
   */
  LCA = 130,

  /**
   * @generated from enum value: LIE = 131;
   */
  LIE = 131,

  /**
   * @generated from enum value: LKA = 132;
   */
  LKA = 132,

  /**
   * @generated from enum value: LSO = 133;
   */
  LSO = 133,

  /**
   * @generated from enum value: LTU = 134;
   */
  LTU = 134,

  /**
   * @generated from enum value: LUX = 135;
   */
  LUX = 135,

  /**
   * @generated from enum value: LVA = 136;
   */
  LVA = 136,

  /**
   * @generated from enum value: MAC = 137;
   */
  MAC = 137,

  /**
   * @generated from enum value: MAF = 138;
   */
  MAF = 138,

  /**
   * @generated from enum value: MAR = 139;
   */
  MAR = 139,

  /**
   * @generated from enum value: MCO = 140;
   */
  MCO = 140,

  /**
   * @generated from enum value: MDA = 141;
   */
  MDA = 141,

  /**
   * @generated from enum value: MDG = 142;
   */
  MDG = 142,

  /**
   * @generated from enum value: MDV = 143;
   */
  MDV = 143,

  /**
   * @generated from enum value: MEX = 144;
   */
  MEX = 144,

  /**
   * @generated from enum value: MHL = 145;
   */
  MHL = 145,

  /**
   * @generated from enum value: MKD = 146;
   */
  MKD = 146,

  /**
   * @generated from enum value: MLI = 147;
   */
  MLI = 147,

  /**
   * @generated from enum value: MLT = 148;
   */
  MLT = 148,

  /**
   * @generated from enum value: MMR = 149;
   */
  MMR = 149,

  /**
   * @generated from enum value: MNE = 150;
   */
  MNE = 150,

  /**
   * @generated from enum value: MNG = 151;
   */
  MNG = 151,

  /**
   * @generated from enum value: MNP = 152;
   */
  MNP = 152,

  /**
   * @generated from enum value: MOZ = 153;
   */
  MOZ = 153,

  /**
   * @generated from enum value: MRT = 154;
   */
  MRT = 154,

  /**
   * @generated from enum value: MSR = 155;
   */
  MSR = 155,

  /**
   * @generated from enum value: MTQ = 156;
   */
  MTQ = 156,

  /**
   * @generated from enum value: MUS = 157;
   */
  MUS = 157,

  /**
   * @generated from enum value: MWI = 158;
   */
  MWI = 158,

  /**
   * @generated from enum value: MYS = 159;
   */
  MYS = 159,

  /**
   * @generated from enum value: MYT = 160;
   */
  MYT = 160,

  /**
   * @generated from enum value: NAM = 161;
   */
  NAM = 161,

  /**
   * @generated from enum value: NCL = 162;
   */
  NCL = 162,

  /**
   * @generated from enum value: NER = 163;
   */
  NER = 163,

  /**
   * @generated from enum value: NFK = 164;
   */
  NFK = 164,

  /**
   * @generated from enum value: NGA = 165;
   */
  NGA = 165,

  /**
   * @generated from enum value: NIC = 166;
   */
  NIC = 166,

  /**
   * @generated from enum value: NIU = 167;
   */
  NIU = 167,

  /**
   * @generated from enum value: NLD = 168;
   */
  NLD = 168,

  /**
   * @generated from enum value: NOR = 169;
   */
  NOR = 169,

  /**
   * @generated from enum value: NPL = 170;
   */
  NPL = 170,

  /**
   * @generated from enum value: NRU = 171;
   */
  NRU = 171,

  /**
   * @generated from enum value: NZL = 172;
   */
  NZL = 172,

  /**
   * @generated from enum value: OMN = 173;
   */
  OMN = 173,

  /**
   * @generated from enum value: PAK = 174;
   */
  PAK = 174,

  /**
   * @generated from enum value: PAN = 175;
   */
  PAN = 175,

  /**
   * @generated from enum value: PCN = 176;
   */
  PCN = 176,

  /**
   * @generated from enum value: PER = 177;
   */
  PER = 177,

  /**
   * @generated from enum value: PHL = 178;
   */
  PHL = 178,

  /**
   * @generated from enum value: PLW = 179;
   */
  PLW = 179,

  /**
   * @generated from enum value: PNG = 180;
   */
  PNG = 180,

  /**
   * @generated from enum value: POL = 181;
   */
  POL = 181,

  /**
   * @generated from enum value: PRI = 182;
   */
  PRI = 182,

  /**
   * @generated from enum value: PRK = 183;
   */
  PRK = 183,

  /**
   * @generated from enum value: PRT = 184;
   */
  PRT = 184,

  /**
   * @generated from enum value: PRY = 185;
   */
  PRY = 185,

  /**
   * @generated from enum value: PSE = 186;
   */
  PSE = 186,

  /**
   * @generated from enum value: PYF = 187;
   */
  PYF = 187,

  /**
   * @generated from enum value: QAT = 188;
   */
  QAT = 188,

  /**
   * @generated from enum value: REU = 189;
   */
  REU = 189,

  /**
   * @generated from enum value: ROU = 190;
   */
  ROU = 190,

  /**
   * @generated from enum value: RUS = 191;
   */
  RUS = 191,

  /**
   * @generated from enum value: RWA = 192;
   */
  RWA = 192,

  /**
   * @generated from enum value: SAU = 193;
   */
  SAU = 193,

  /**
   * @generated from enum value: SDN = 194;
   */
  SDN = 194,

  /**
   * @generated from enum value: SEN = 195;
   */
  SEN = 195,

  /**
   * @generated from enum value: SGP = 196;
   */
  SGP = 196,

  /**
   * @generated from enum value: SGS = 197;
   */
  SGS = 197,

  /**
   * @generated from enum value: SHN = 198;
   */
  SHN = 198,

  /**
   * @generated from enum value: SJM = 199;
   */
  SJM = 199,

  /**
   * @generated from enum value: SLB = 200;
   */
  SLB = 200,

  /**
   * @generated from enum value: SLE = 201;
   */
  SLE = 201,

  /**
   * @generated from enum value: SLV = 202;
   */
  SLV = 202,

  /**
   * @generated from enum value: SMR = 203;
   */
  SMR = 203,

  /**
   * @generated from enum value: SOM = 204;
   */
  SOM = 204,

  /**
   * @generated from enum value: SPM = 205;
   */
  SPM = 205,

  /**
   * @generated from enum value: SRB = 206;
   */
  SRB = 206,

  /**
   * @generated from enum value: SSD = 207;
   */
  SSD = 207,

  /**
   * @generated from enum value: STP = 208;
   */
  STP = 208,

  /**
   * @generated from enum value: SUR = 209;
   */
  SUR = 209,

  /**
   * @generated from enum value: SVK = 210;
   */
  SVK = 210,

  /**
   * @generated from enum value: SVN = 211;
   */
  SVN = 211,

  /**
   * @generated from enum value: SWE = 212;
   */
  SWE = 212,

  /**
   * @generated from enum value: SWZ = 213;
   */
  SWZ = 213,

  /**
   * @generated from enum value: SXM = 214;
   */
  SXM = 214,

  /**
   * @generated from enum value: SYC = 215;
   */
  SYC = 215,

  /**
   * @generated from enum value: SYR = 216;
   */
  SYR = 216,

  /**
   * @generated from enum value: TCA = 217;
   */
  TCA = 217,

  /**
   * @generated from enum value: TCD = 218;
   */
  TCD = 218,

  /**
   * @generated from enum value: TGO = 219;
   */
  TGO = 219,

  /**
   * @generated from enum value: THA = 220;
   */
  THA = 220,

  /**
   * @generated from enum value: TJK = 221;
   */
  TJK = 221,

  /**
   * @generated from enum value: TKL = 222;
   */
  TKL = 222,

  /**
   * @generated from enum value: TKM = 223;
   */
  TKM = 223,

  /**
   * @generated from enum value: TLS = 224;
   */
  TLS = 224,

  /**
   * @generated from enum value: TON = 225;
   */
  TON = 225,

  /**
   * @generated from enum value: TTO = 226;
   */
  TTO = 226,

  /**
   * @generated from enum value: TUN = 227;
   */
  TUN = 227,

  /**
   * @generated from enum value: TUR = 228;
   */
  TUR = 228,

  /**
   * @generated from enum value: TUV = 229;
   */
  TUV = 229,

  /**
   * @generated from enum value: TWN = 230;
   */
  TWN = 230,

  /**
   * @generated from enum value: TZA = 231;
   */
  TZA = 231,

  /**
   * @generated from enum value: UGA = 232;
   */
  UGA = 232,

  /**
   * @generated from enum value: UKR = 233;
   */
  UKR = 233,

  /**
   * @generated from enum value: UMI = 234;
   */
  UMI = 234,

  /**
   * @generated from enum value: URY = 235;
   */
  URY = 235,

  /**
   * @generated from enum value: UZB = 236;
   */
  UZB = 236,

  /**
   * @generated from enum value: VAT = 237;
   */
  VAT = 237,

  /**
   * @generated from enum value: VCT = 238;
   */
  VCT = 238,

  /**
   * @generated from enum value: VEN = 239;
   */
  VEN = 239,

  /**
   * @generated from enum value: VGB = 240;
   */
  VGB = 240,

  /**
   * @generated from enum value: VIR = 241;
   */
  VIR = 241,

  /**
   * @generated from enum value: VNM = 242;
   */
  VNM = 242,

  /**
   * @generated from enum value: VUT = 243;
   */
  VUT = 243,

  /**
   * @generated from enum value: WLF = 244;
   */
  WLF = 244,

  /**
   * @generated from enum value: WSM = 245;
   */
  WSM = 245,

  /**
   * @generated from enum value: YEM = 246;
   */
  YEM = 246,

  /**
   * @generated from enum value: ZAF = 247;
   */
  ZAF = 247,

  /**
   * @generated from enum value: ZMB = 248;
   */
  ZMB = 248,

  /**
   * @generated from enum value: ZWE = 249;
   */
  ZWE = 249,

  /**
   * *
   * As of 2021-09-30, Cash currently uses XXL to represent Ireland, not IRL.
   * If things change in the future, please deprecate this key,
   * See go/$customer-region
   *
   * @generated from enum value: XXL = 900;
   */
  XXL = 900,

  /**
   * *
   * For shadow load testing only
   *
   * @generated from enum value: XTS = 963;
   */
  XTS = 963,
}

/**
 * Describes the enum squareup.franklin.Region.
 */
export const RegionSchema: GenEnum<Region> = /*@__PURE__*/
  enumDesc(file_squareup_franklin_region, 0);

